module.exports = __webpack_public_path__ + "static/media/wga.6131e99d.png";